
import { Link } from 'react-router-dom';

export default function ConstipationMedicineGuidePage() {
  // 便秘薬の種類データ
  const medicineTypes = [
    {
      category: "刺激性下剤",
      medicines: ["センナ", "ビサコジル", "ピコスルファート", "大黄"],
      mechanism: "腸壁を直接刺激して腸の蠕動運動を促進し、排便を誘発します。大腸の神経叢に作用して、強制的に腸の動きを活発化させます。",
      usage: "就寝前に服用し、翌朝の排便を期待します。効果は6-12時間後に現れることが多いです。",
      advantages: [
        "即効性があり、確実な効果が期待できる",
        "頑固な便秘にも効果的",
        "比較的安価で入手しやすい"
      ],
      disadvantages: [
        "習慣性があり、長期使用で効果が減弱する",
        "腹痛や下痢を起こしやすい",
        "電解質バランスの乱れを起こす可能性"
      ],
      precautions: "連続使用は避け、週2-3回程度の使用に留めることが推奨されます。妊娠中の使用は医師に相談してください。"
    },
    {
      category: "浸透圧性下剤",
      medicines: ["酸化マグネシウム", "ラクツロース", "マクロゴール"],
      mechanism: "腸内に水分を引き込んで便を軟らかくし、便量を増加させることで自然な排便を促します。腸管からの水分吸収を阻害します。",
      usage: "食後または食間に十分な水分と一緒に服用します。効果は1-3日で現れることが多いです。",
      advantages: [
        "習慣性が少なく、長期使用が可能",
        "自然な排便に近い効果",
        "副作用が比較的少ない"
      ],
      disadvantages: [
        "効果が現れるまで時間がかかる",
        "腎機能低下時は注意が必要",
        "下痢になりやすい場合がある"
      ],
      precautions: "腎機能障害のある方は医師に相談してください。十分な水分摂取が必要です。"
    },
    {
      category: "膨張性下剤",
      medicines: ["プランタゴ・オバタ", "メチルセルロース", "カルメロース"],
      mechanism: "水分を吸収して膨張し、便量を増加させて腸壁を刺激します。食物繊維と同様の作用で自然な排便を促進します。",
      usage: "十分な水分（コップ1-2杯）と一緒に服用します。効果は1-3日で現れます。",
      advantages: [
        "最も自然な排便メカニズム",
        "習慣性がない",
        "食物繊維不足を補える"
      ],
      disadvantages: [
        "効果が穏やかで時間がかかる",
        "腸閉塞のリスクがある",
        "十分な水分摂取が必須"
      ],
      precautions: "水分摂取が不十分だと腸閉塞を起こす可能性があります。嚥下困難のある方は注意が必要です。"
    },
    {
      category: "潤滑性下剤",
      medicines: ["流動パラフィン", "グリセリン浣腸"],
      mechanism: "便の表面を滑らかにして腸管内での移動を容易にします。また、腸壁への刺激も軽減します。",
      usage: "経口薬は食間に、浣腸は必要時に使用します。効果は比較的早く現れます。",
      advantages: [
        "即効性がある",
        "腹痛が少ない",
        "高齢者にも使いやすい"
      ],
      disadvantages: [
        "脂溶性ビタミンの吸収を阻害",
        "長期使用で栄養失調のリスク",
        "誤嚥性肺炎のリスク"
      ],
      precautions: "長期使用は避け、脂溶性ビタミン（A、D、E、K）の不足に注意してください。"
    },
    {
      category: "新しいタイプ",
      medicines: ["ルビプロストン", "リナクロチド", "エロビキシバット"],
      mechanism: "腸管分泌を促進したり、腸管運動を調節する新しい作用機序で便秘を改善します。従来の下剤とは異なるアプローチです。",
      usage: "医師の処方に従って服用します。効果は個人差がありますが、比較的早期に現れることが多いです。",
      advantages: [
        "新しい作用機序で効果的",
        "習慣性が少ない",
        "慢性便秘に適している"
      ],
      disadvantages: [
        "処方薬のため医師の診察が必要",
        "比較的高価",
        "副作用の情報が限定的"
      ],
      precautions: "医師の指示に従って使用し、副作用が現れた場合は速やかに相談してください。"
    }
  ];

  // 使用のコツ
  const usageTips = [
    {
      icon: "ri-time-line",
      title: "適切なタイミング",
      description: "刺激性下剤は就寝前、浸透圧性下剤は食後に服用するなど、薬の特性に応じたタイミングで服用しましょう。"
    },
    {
      icon: "ri-drop-line",
      title: "十分な水分摂取",
      description: "便秘薬の効果を高めるため、1日1.5-2リットルの水分摂取を心がけましょう。特に膨張性下剤では必須です。"
    },
    {
      icon: "ri-calendar-check-line",
      title: "使用期間の管理",
      description: "刺激性下剤は短期間の使用に留め、長期使用が必要な場合は浸透圧性下剤を選択しましょう。"
    },
    {
      icon: "ri-user-heart-line",
      title: "個人に合った選択",
      description: "年齢、体質、他の薬との相互作用を考慮して、自分に最適な便秘薬を選択することが重要です。"
    }
  ];

  // 危険な症状
  const warningSignals = [
    "激しい腹痛や嘔吐",
    "血便や黒色便",
    "発熱を伴う便秘",
    "急激な体重減少",
    "便秘薬を使っても全く効果がない",
    "腹部の異常な膨満感",
    "排便時の激痛",
    "便秘と下痢を繰り返す"
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-orange-600" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-orange-600 transition-colors">ホーム</Link>
              <Link to="/services" className="text-gray-700 hover:text-orange-600 transition-colors">サービス</Link>
              <Link to="/beast-blog" className="text-orange-600 font-medium">ビースト君ブログ</Link>
              <Link to="/information" className="text-gray-700 hover:text-orange-600 transition-colors">お知らせ</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-50 to-blue-50 py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-capsule-line text-3xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              便秘薬の正しい使い方と種類の違いをわかりやすく解説
            </h1>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <nav className="bg-gray-50 py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-teal-600 cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/beast-blog" className="text-gray-500 hover:text-teal-600 cursor-pointer">ビースト君ブログ</Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900">便秘薬の正しい使い方</span>
          </div>
        </div>
      </nav>

      {/* Article Header */}
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <header className="mb-12">
          <div className="flex items-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/dbe372861181c69374dfc05760b8ebc3.jpg"
                alt="ビースト君"
                className="w-14 h-14 object-cover object-top rounded-full border-2 border-teal-300"
              />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="bg-purple-100 text-purple-800 text-sm px-3 py-1 rounded-full font-medium">OTC医薬品</span>
                <span className="bg-red-100 text-red-800 text-sm px-3 py-1 rounded-full font-medium">NEW</span>
                <span className="text-gray-500 text-sm">2025年10月9日</span>
              </div>
              <p className="text-gray-600">ビースト君 • 薬剤師</p>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            便秘薬の正しい使い方と種類の違いをわかりやすく解説
          </h1>
          
          <div className="relative mb-8">
            <img 
              src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20modern%20pharmacy%20explaining%20different%20types%20of%20constipation%20medicines%20with%20various%20medicine%20bottles%20and%20educational%20charts%20displayed%20on%20consultation%20table%2C%20professional%20healthcare%20setting%20showing%20different%20categories%20of%20laxatives%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background%20and%20digestive%20system%20illustrations&width=800&height=400&seq=beast-constipation-medicine-hero&orientation=landscape"
              alt="便秘薬について説明するビースト君"
              className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-600 leading-relaxed">
              こんにちは、ビースト君です！💪 今日は多くの方が悩んでいる便秘と、その治療薬について詳しく解説します。
              便秘薬にはたくさんの種類があり、それぞれ作用メカニズムが異なります。
              筋トレで体を鍛えている私も、食事や生活習慣の変化で便秘に悩むことがあります。
              正しい知識を持って、適切な便秘薬を選びましょう！
            </p>
          </div>
        </header>

        {/* Introduction */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">便秘薬の基本的な分類</h2>
          
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-8 mb-8">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-medicine-bottle-line text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">便秘薬の作用による分類</h3>
                <div className="space-y-3 text-gray-700">
                  <p><strong>刺激性下剤：</strong>腸の動きを直接刺激して排便を促す</p>
                  <p><strong>浸透圧性下剤：</strong>腸内に水分を引き込んで便を軟らかくする</p>
                  <p><strong>膨張性下剤：</strong>水分を吸収して膨らみ、腸を刺激する</p>
                  <p><strong>潤滑性下剤：</strong>便の表面を滑らかにして排出しやすくする</p>
                  <p><strong>新しいタイプ：</strong>腸管分泌を促進する新しい作用機序</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            便秘薬は作用メカニズムによって大きく5つのタイプに分類されます。
            それぞれに特徴があり、便秘の原因や症状、患者さんの状態に応じて使い分けることが重要です。
          </p>
        </section>

        {/* Medicine Types Detail */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">便秘薬の種類別詳細解説</h2>
          
          <div className="space-y-8">
            {medicineTypes.map((type, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-capsule-line text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-teal-600">{type.category}</h3>
                </div>
                
                <div className="grid lg:grid-cols-2 gap-8">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">主な薬剤</h4>
                    <div className="flex flex-wrap gap-2 mb-6">
                      {type.medicines.map((medicine, idx) => (
                        <span key={idx} className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full">
                          {medicine}
                        </span>
                      ))}
                    </div>
                    
                    <h4 className="font-semibold text-gray-900 mb-3">作用メカニズム</h4>
                    <p className="text-gray-700 mb-6">{type.mechanism}</p>
                    
                    <h4 className="font-semibold text-gray-900 mb-3">使用方法</h4>
                    <p className="text-gray-700">{type.usage}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">メリット</h4>
                    <ul className="space-y-2 mb-6">
                      {type.advantages.map((advantage, idx) => (
                        <li key={idx} className="flex items-start">
                          <div className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                          <span className="text-gray-700">{advantage}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <h4 className="font-semibold text-gray-900 mb-3">デメリット・注意点</h4>
                    <ul className="space-y-2 mb-6">
                      {type.disadvantages.map((disadvantage, idx) => (
                        <li key={idx} className="flex items-start">
                          <div className="w-2 h-2 bg-red-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                          <span className="text-gray-700">{disadvantage}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                      <h5 className="font-semibold text-yellow-800 mb-2">重要な注意事項</h5>
                      <p className="text-yellow-700 text-sm">{type.precautions}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Usage Tips */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">便秘薬を効果的に使うためのコツ</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {usageTips.map((tip, index) => (
              <div key={index} className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-6 border border-green-100">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${tip.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{tip.title}</h3>
                    <p className="text-gray-700">{tip.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Warning Signals */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">すぐに医師に相談すべき症状</h2>
          
          <div className="bg-red-50 border border-red-200 rounded-xl p-8">
            <div className="flex items-start mb-6">
              <div className="w-12 h-12 bg-red-100 text-red-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-alarm-warning-line text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-red-800 mb-3">危険な症状</h3>
                <p className="text-red-700">以下の症状がある場合は、便秘薬の使用を中止し、すぐに医師に相談してください。</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              {warningSignals.map((signal, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-2 h-2 bg-red-500 rounded-full mr-3 flex-shrink-0"></div>
                  <span className="text-red-700">{signal}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Beast-kun's Experience */}
        <section className="mb-12">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8">
            <div className="flex items-start">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                <img 
                  src="https://readdy.ai/api/search-image?query=Friendly%20muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20and%20white%20coat%2C%20cartoon%20mascot%20style%2C%20cheerful%20expression%2C%20strong%20build%2C%20professional%20healthcare%20worker%2C%20anime%20character%20design%20with%20defined%20muscles%2C%20welcoming%20pose%2C%20clean%20simple%20background&width=60&height=60&seq=beast-kun-experience-constipation&orientation=squarish"
                  alt="ビースト君"
                  className="w-14 h-14 object-cover object-top rounded-full border-2 border-teal-300"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-teal-600 mb-4">ビースト君の薬剤師としてのアドバイス</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    薬局でよく「どの便秘薬がいいですか？」と聞かれますが、実は便秘の原因や症状によって最適な薬は変わります。
                    急性の便秘には刺激性下剤が効果的ですが、慢性便秘には浸透圧性下剤の方が適している場合が多いんです。
                  </p>
                  <p>
                    筋トレをしている私の経験から言うと、プロテインの摂取量を増やした時期に便秘になりやすくなりました。
                    その時は水分摂取を増やし、酸化マグネシウムを使用することで改善しました。
                  </p>
                  <p>
                    便秘薬は「症状を和らげる」ものであって、根本的な解決にはなりません。
                    食事、運動、生活習慣の改善と併用することが大切です。
                    迷った時は、遠慮なく薬剤師に相談してくださいね！💪
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">まとめ</h2>
          
          <div className="bg-white border-2 border-teal-200 rounded-xl p-8">
            <div className="space-y-4 text-gray-700">
              <p>
                便秘薬には多くの種類があり、それぞれ異なる作用メカニズムを持っています。
                自分の便秘の原因や症状に合った薬を選ぶことが、効果的な治療につながります。
              </p>
              <p>
                刺激性下剤は即効性がありますが習慣性があるため、長期使用は避けましょう。
                浸透圧性下剤は比較的安全に長期使用できますが、腎機能に注意が必要です。
              </p>
              <p>
                便秘薬だけに頼らず、食事・運動・生活習慣の改善も同時に行うことが重要です。
                症状が改善しない場合や危険な症状がある場合は、必ず医師に相談してください。
              </p>
            </div>
          </div>
        </section>

        {/* Related Articles */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">関連記事</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <Link to="/beast-blog/supplement-drug-interactions" className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow cursor-pointer">
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-capsule-line"></i>
                </div>
                <span className="text-sm text-gray-500">2025.10.08</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">サプリメントと薬の飲み合わせは大丈夫？</h3>
              <p className="text-gray-600">サプリメントと薬の相互作用について詳しく解説します。</p>
            </Link>
            
            <Link to="/beast-blog/otc-selection" className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow cursor-pointer">
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-medicine-bottle-line"></i>
                </div>
                <span className="text-sm text-gray-500">2025.10.02</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">市販薬選びで失敗しないコツ</h3>
              <p className="text-gray-600">症状別の市販薬の選び方について解説します。</p>
            </Link>
          </div>
        </section>

        {/* Back to Blog */}
        <div className="text-center">
          <Link 
            to="/beast-blog" 
            className="inline-flex items-center bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            ビースト君ブログ一覧に戻る
          </Link>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プタフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
